import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {db_tables, DBHelpers, msg, rd, type_modal, type_modal_icon, type_popup, website, websites} from "../../vars/rd";
import PageBack from "../components/buttons/page-back";
import CategoryBusiness from "../components/buttons/category.business";
import {$, jsi} from "../../index";
import {popupShow} from "../../libs/redux/actions/popup";
import {modalShow} from "../../libs/redux/actions/modal";
import DaoUser from "../../modules/dao/user";
import {sidebarShow} from "../../libs/redux/actions/sidebar";

class Mypage extends Component {
    msg;
    sidebar;
    constructor(props) {
        super(props);

        this.msg = msg();

        this.state = {
            user: rd.user
        };
    }

    componentDidMount() {
        this.sidebar = $(".sidebar");
        window.addEventListener("resize", this.onWindowResize);
        this.onWindowResize();
    }


    componentWillUnmount() {
        window.removeEventListener("resize", this.onWindowResize);
        this.sidebar = null;
    }

    onWindowResize = () => {
        if(this.sidebar.length) {
            if(window.innerWidth < 768) {
                this.dispatch(sidebarShow());
            }
        }

    };

    get dispatch() {
        return this.props.hasOwnProperty("dispatch") ? this.props.dispatch : () => {};
    }

    /**
     * @returns {DaoUser}
     */
    get user() {
        return this.state.user;
    }

    shopBusinessEdit() {
        this.dispatch(popupShow(type_popup.business, this.user.shopBusiness));
    }

    logOut() {
        this.dispatch(
            modalShow(
                type_modal.confirm,
                {
                    icon: type_modal_icon.warn,
                    header: this.msg.logout,
                    message: this.msg.confirm_logout,
                    buttons: {
                        yes: this.msg.logout
                    }
                },
                async (rs) => {
                    if (rs) {
                        DBHelpers.openDB()
                            .then(async db => {
                                try {
                                    const users = await db.select(db_tables.users, () => true);
                                    if (users) {
                                        await db.updateBulk(db_tables.users, {...users, mac: null}, doc => {
                                            return doc.id === users.id
                                        });
                                    }
                                } catch (e) {
                                } finally {
                                    rd.user = new DaoUser();
                                    jsi.jsi_logout();
                                }
                            });
                    }
                }
            )
        );
    }

    /**
     * @param e
     */
    profileError(e) {
        if (e) {
            e.target.onerror = null;
            e.target.src = "/images/avatar.png";
        }
    }

    openBrowser(url) {
        jsi.jsi_open_browser(url);
    }

    render() {
        return (
            <div className="mypage">
                <div className="mypage-wrap">
                    <h2>
                        <PageBack />
                        마이페이지
                    </h2>
                    <div className="mypage-cont">
                        <div className="mypage-left">
                            <div className="mypage-box">
                                <div className="mytop">
                                    <div className="image">
                                        <span>
                                            <img src={rd.user.shopImage} alt={rd.user.shopName}
                                                 onError={e => this.profileError(e)}/>
                                        </span>
                                    </div>
                                    <div className="title1">{this.user.bizname}</div>
                                    <div className="title2"> {this.user.shopName}</div>
                                </div>
                                <div className="mytype">
                                    <h4>내 업종<span onClick={() => this.shopBusinessEdit()}><img src="/images/icon-modify.png" alt={''} /></span></h4>
                                    <div className="type-wrap">
                                        <CategoryBusiness category={this.user.shopBusiness} is_mypage={true} />
                                    </div>
                                </div>
                            </div>
                            <div className="btn-logout" onClick={() => this.logOut()}><span className="btn-s1 w100 btn-m">로그아웃</span></div>
                        </div>
                        <div className="mypage-right">
                            <div className="mypage-info">
                                <dl>
                                    <dt className="title">상호명</dt>
                                    <dd className="text">
                                        {`${this.user.bizname} - ` || ''}
                                        {this.user.shopName}
                                    </dd>
                                </dl>
                                <dl>
                                    <dt className="title">아이디</dt>
                                    <dd className="text">{this.user.id}</dd>
                                </dl>
                                <dl>
                                    <dt className="title">매장 주소</dt>
                                    <dd className="text">{this.user.shopAddress}</dd>
                                </dl>
                                <dl>
                                    <dt className="title">휴대전화번호</dt>
                                    <dd className="text">{this.user.mobile}</dd>
                                </dl>
                            </div>
                            <div className="mypage-link-wrap">
                                상세한 정보 확인 및 수정은 홈페이지에서 가능합니다.
                                <span className="btn-link" onClick={() => this.openBrowser(website(websites.destination, {query: rd.user.websiteParameters("mypage")}))}>
                                    홈페이지에서 보기
                                    <img src="/images/icon-link.png" alt={''} />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

const userStateToProps = (state) => ({
    user: state.user,
});

export default connect(userStateToProps)(withRouter(Mypage));


// WEBPACK FOOTER //
// ./src/pages/mypage/index.jsx